import React, { useEffect, useRef, useState } from "react";
import ModalPortal from "~/common/components/ModalPortal/index";
import PropsProvider from "~/common/components/PropsProvider";

//Assets
import "~/assets/sass/component/modal.scss";
import { SolidCloseIcon } from "~/assets/svg/CloseIcon";

const ModalTemplate = (props) => {
	const {
		modalState,
		setModalToggle,
		closeModal,
		title,
		children,
		mask,
		width,
		height,
		className,
		closeable,
		onClose
	} = props;

	const [modalTitle, setModalTitle] = useState("");

	const modalRef = useRef(null);

	useEffect(() => {
		setModalTitle(title);
	}, [title]);

	const clickOutside = (e) => {
		if (modalRef.current && !modalRef.current.contains(e.target)) {
			closeable && setModalToggle(false);
		}
	};

	useEffect(() => {
		document.addEventListener("mousedown", clickOutside);
		return () => {
			document.removeEventListener("mousedown", clickOutside);
		};
	}, [modalRef]);

	if (!modalState) {
		return <></>;
	} else {
		return (
			<ModalPortal>
				<div className={`c__modal toggleOpen ${mask && "show-mask"} ${className}`}>
					<div
						className="modal-container"
						style={{ width: width, minHeight: height }}
						ref={modalRef}
					>
						<div className="modal-header">
							<p className="modal-title">{modalTitle || ""}</p>
							<button className="modal-close" onClick={() => {
								if(closeModal) {
									closeModal();
								} else {
									setModalToggle(false); onClose && onClose()
								}
							}}>
								<SolidCloseIcon />
							</button>
						</div>
						<div className="modal-body">
							<PropsProvider props={{ modalState, setModalToggle, setModalTitle }}>
								{children}
							</PropsProvider>
						</div>
					</div>
				</div>
			</ModalPortal>
		);
	}
};

export default ModalTemplate;

ModalTemplate.defaultProps = {
	mask: true,
	width: 1000,
	minHeight: 500,
	closeable: false,
};
